module.exports = __webpack_public_path__ + "img/Realisme_Tanker_i_tida6.94ea6035.jpg";